const itCompanyConfig = {
  businessName: "NexaCore Technologies",
  businessCategory: "IT Company & Software Solutions",
  tagline: "Engineering the Future, One Line at a Time",
  description:
    "NexaCore Technologies is a full-service IT company delivering cutting-edge software development, cloud solutions, cybersecurity, AI/ML, and digital transformation services to businesses worldwide.",
  mission:
    "To empower businesses with innovative technology solutions that drive growth, efficiency, and competitive advantage.",
  vision:
    "To be a globally recognized technology partner known for engineering excellence, innovation, and client success.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#6366f1",
    secondaryColor: "#0ea5e9",
    accentColor: "#22d3ee",
    backgroundColor: "#ffffff",
    textColor: "#0f172a",
    darkBackground: "#0f172a",
    darkText: "#f1f5f9",
    borderRadius: "12px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "NexaCore Technologies | Software & IT Solutions",
    description:
      "NexaCore Technologies delivers world-class software development, cloud, AI/ML, cybersecurity, and digital transformation services. Let's build something great.",
    keywords:
      "IT company, software development, web development, mobile app, cloud, AI, cybersecurity, digital transformation, NexaCore",
    ogImage:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 10101",
    whatsapp: "919876510101",
    email: "hello@nexacore.tech",
    website: "www.nexacore.tech",
    address: "Level 8, Tech Tower, Whitefield, Bengaluru - 560066, India",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday â€“ Friday", hours: "9:00 AM â€“ 7:00 PM IST" },
    { day: "Saturday", hours: "10:00 AM â€“ 4:00 PM IST" },
    { day: "Sunday", hours: "Closed (Emergency Support Available)" },
  ],
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
    twitter: "https://twitter.com",
  },
  hero: {
    heading: "Build Smarter. Scale Faster. Innovate Always.",
    subheading:
      "From custom software to AI-powered platforms â€” we engineer technology solutions that transform your business.",
    ctaPrimary: { label: "Start a Project", link: "/itcompany/contact" },
    ctaSecondary: { label: "Explore Services", link: "/itcompany/services" },
    images: [
      "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1400&q=80",
      "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=1400&q=80",
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1400&q=80",
    ],
  },
  about: {
    heading: "About NexaCore Technologies",
    subheading: "Delivering Technology Excellence Since 2012",
    body: "Founded in 2012, NexaCore Technologies has grown from a 5-person startup to a 300+ strong team of engineers, designers, and strategists. We have successfully delivered 500+ projects across 30+ countries, helping startups, SMEs, and Fortune 500 companies harness the power of technology.",
    highlights: [
      "300+ Engineers & Designers",
      "500+ Projects Delivered",
      "30+ Countries Served",
      "ISO 27001 Certified",
    ],
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80",
  },
  services: [
    {
      id: 1,
      icon: "FaMobileAlt",
      title: "Web & Mobile Development",
      description:
        "Custom web applications, progressive web apps, iOS & Android mobile apps built with React, Flutter, Node.js, and more.",
      image: "",
    },
    {
      id: 2,
      icon: "FaBuilding",
      title: "Cloud Solutions",
      description:
        "Cloud migration, architecture design, DevOps, and managed services on AWS, Azure, and Google Cloud Platform.",
      image: "",
    },
    {
      id: 3,
      icon: "FaChartLine",
      title: "AI & Machine Learning",
      description:
        "Intelligent automation, predictive analytics, NLP, computer vision, and custom AI model development.",
      image: "",
    },
    {
      id: 4,
      icon: "FaShieldAlt",
      title: "Cybersecurity",
      description:
        "Penetration testing, vulnerability assessments, SOC services, and end-to-end security architecture.",
      image: "",
    },
    {
      id: 5,
      icon: "FaChartLine",
      title: "Data Analytics & BI",
      description:
        "Data engineering, business intelligence dashboards, real-time analytics, and data warehouse solutions.",
      image: "",
    },
    {
      id: 6,
      icon: "FaPaintBrush",
      title: "UI/UX Design",
      description:
        "User research, wireframing, prototyping, and pixel-perfect design systems for web and mobile products.",
      image: "",
    },
    {
      id: 7,
      icon: "FaBuilding",
      title: "ERP & CRM Solutions",
      description:
        "Custom ERP, CRM, and HRMS implementations tailored to your business workflows and processes.",
      image: "",
    },
    {
      id: 8,
      icon: "FaMobileAlt",
      title: "IT Consulting",
      description:
        "Technology roadmap planning, digital transformation strategy, and CTO-as-a-service for growing businesses.",
      image: "",
    },
  ],
  stats: [
    { value: 500, label: "Projects Delivered", suffix: "+" },
    { value: 300, label: "Team Members", suffix: "+" },
    { value: 30, label: "Countries Served", suffix: "+" },
    { value: 12, label: "Years of Excellence", suffix: "+" },
  ],
  whyUs: {
    heading: "Why Partner with NexaCore?",
    subheading: "Technology expertise meets business understanding",
    points: [
      {
        icon: "FaShieldAlt",
        title: "Proven Expertise",
        description:
          "300+ certified engineers across 20+ technologies with deep domain expertise.",
      },
      {
        icon: "FaClock",
        title: "On-Time Delivery",
        description:
          "Agile methodology with sprint-based delivery â€” 96% of projects delivered on time.",
      },
      {
        icon: "FaChartLine",
        title: "Scalable Solutions",
        description:
          "Architecture designed to scale from 100 to 10 million users without breaking a sweat.",
      },
      {
        icon: "FaUserMd",
        title: "Dedicated Support",
        description:
          "24/7 post-launch support, SLA-backed maintenance, and a dedicated account manager.",
      },
    ],
  },
  gallery: [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80",
      alt: "Tech Infrastructure",
      category: "Infrastructure",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80",
      alt: "Software Development",
      category: "Development",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80",
      alt: "Team Collaboration",
      category: "Team",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80",
      alt: "Office Space",
      category: "Office",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800&q=80",
      alt: "AI & Data Science",
      category: "AI & Data",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
      alt: "Team Meeting",
      category: "Team",
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
      alt: "Cybersecurity",
      category: "Security",
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80",
      alt: "Web Development",
      category: "Development",
    },
  ],
  pricing: [
    {
      id: 1,
      name: "Starter",
      price: "â‚¹49,999",
      period: "per project",
      features: [
        "Up to 5 Pages / Screens",
        "Responsive Design",
        "Basic SEO Setup",
        "3 Months Free Support",
        "Source Code Handover",
      ],
      highlighted: false,
    },
    {
      id: 2,
      name: "Growth",
      price: "â‚¹1,49,999",
      period: "per project",
      features: [
        "Full Web or Mobile App",
        "Custom UI/UX Design",
        "API Integration",
        "Admin Dashboard",
        "6 Months Free Support",
        "Cloud Deployment",
      ],
      highlighted: true,
    },
    {
      id: 3,
      name: "Enterprise",
      price: "Custom",
      period: "get a quote",
      features: [
        "End-to-End Product Build",
        "Dedicated Dev Team",
        "AI/ML Integration",
        "DevOps & CI/CD Pipeline",
        "12 Months SLA Support",
        "NDA & IP Protection",
      ],
      highlighted: false,
    },
  ],
  testimonials: [
    {
      id: 1,
      name: "Rahul Singhania",
      role: "CTO, FinEdge Startup",
      review:
        "NexaCore built our entire fintech platform from scratch in just 4 months. The code quality, architecture, and communication were all top-notch. Highly recommend!",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
    },
    {
      id: 2,
      name: "Sarah Mitchell",
      role: "VP Engineering, RetailMax USA",
      review:
        "We outsourced our entire mobile app development to NexaCore. They delivered ahead of schedule, and the app has a 4.8-star rating on the App Store. Exceptional team.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
    },
    {
      id: 3,
      name: "Aditya Verma",
      role: "Founder, HealthTrack SaaS",
      review:
        "The AI recommendation engine NexaCore built for us increased user engagement by 60%. Their data science team truly understands business problems.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80",
    },
  ],
  team: [
    {
      id: 1,
      name: "Vikram Anand",
      role: "CEO & Co-Founder",
      bio: "IIT Bombay alumnus, 15+ years in enterprise software and product strategy.",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 2,
      name: "Neha Krishnan",
      role: "CTO & Co-Founder",
      bio: "Ex-Google engineer, expert in distributed systems and cloud architecture.",
      image:
        "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 3,
      name: "Arjun Mehta",
      role: "Head of AI & Data Science",
      bio: "PhD in Machine Learning, previously at Microsoft Research.",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 4,
      name: "Priya Desai",
      role: "Head of Design",
      bio: "Award-winning UX designer with 10+ years across fintech and healthtech.",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
  ],
  faq: [
    {
      id: 1,
      question: "What technologies do you work with?",
      answer:
        "We work across the full stack â€” React, Next.js, Node.js, Python, Flutter, Swift, Kotlin, AWS, Azure, GCP, PostgreSQL, MongoDB, and more. We choose the best tech for your specific use case.",
    },
    {
      id: 2,
      question: "How do you handle project communication?",
      answer:
        "Every project gets a dedicated project manager. We use Jira for task tracking, Slack for communication, and hold weekly sprint review calls. You always know exactly where your project stands.",
    },
    {
      id: 3,
      question: "Do you sign NDAs?",
      answer:
        "Absolutely. We sign NDAs before any project discussion. Your idea, code, and data are fully protected under our IP agreement.",
    },
    {
      id: 4,
      question: "Can you work with our existing development team?",
      answer:
        "Yes. We offer team augmentation services where our engineers integrate seamlessly with your in-house team, following your processes and tools.",
    },
    {
      id: 5,
      question: "What is your post-launch support policy?",
      answer:
        "All projects include free bug-fix support for 3â€“12 months depending on the package. We also offer ongoing AMC (Annual Maintenance Contracts) for long-term support.",
    },
  ],
  cta: {
    heading: "Ready to Build Something Extraordinary?",
    subheading:
      "Tell us about your project and get a free consultation and estimate within 24 hours.",
    buttonLabel: "Get a Free Consultation",
    buttonLink: "/itcompany/contact",
  },
  footer: {
    tagline: "Engineering the Future, One Line at a Time.",
    copyright: `Â© ${new Date().getFullYear()} NexaCore Technologies Pvt. Ltd. All Rights Reserved.`,
    links: [
      { label: "Home", path: "/itcompany" },
      { label: "Services", path: "/itcompany/services" },
      { label: "Portfolio", path: "/itcompany/gallery" },
      { label: "Contact", path: "/itcompany/contact" },
    ],
  },
  productsLabel: "Software & Tools",
  products: [
    { id: 1, name: "Website Development Package", category: "Web", price: 49999, originalPrice: 75000, image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&q=80", description: "5-page responsive website, SEO setup, CMS, 3 months support. Delivered in 3 weeks.", badge: "Best Seller", inStock: true },
    { id: 2, name: "Mobile App - MVP Build", category: "Mobile", price: 149999, originalPrice: null, image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=600&q=80", description: "Cross-platform Flutter app, up to 10 screens, API integration, 6 months support.", badge: "Popular", inStock: true },
    { id: 3, name: "UI/UX Design Sprint", category: "Design", price: 24999, originalPrice: 35000, image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&q=80", description: "Full product design - wireframes, prototypes, design system. Delivered in 2 weeks.", badge: "Fast Delivery", inStock: true },
    { id: 4, name: "Cloud Setup and DevOps", category: "Cloud", price: 34999, originalPrice: null, image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80", description: "AWS/GCP setup, CI/CD pipeline, Docker, monitoring and auto-scaling configuration.", badge: null, inStock: true },
  ],
  sections: {
    hero: true,
    about: true,
    services: true,
    whyUs: true,
    stats: true,
    gallery: true,
    pricing: true,
    testimonials: true,
    team: true,
    faq: true,
    cta: true,
    contact: true,
    products: true,
    enquireMode: true,
  },
};

export default itCompanyConfig;
